/*
 * @description:
 * @author: Jason Wong
 * @since: 2023-01-06 16:37:33
 */
import Diff from "../util/diff";
import domHelper from "../util/dom.js";
const DIFF = new Diff();
class TextChange {
    constructor(type, pos, data) {
        this.t = type;
        this.p = pos;
        this.d = data;
    }
}
const CHANGE_TYPE = {
    insert: 0,
    delete: 1,
};

function compare(str1, str2) {
    let changes = [];

    let pos = 0;
    for (const seg of DIFF.main(str1, str2)) {
        switch (seg[0]) {
            case DIFF_EQUAL:
                pos += seg[1].length;
                break;
            case DIFF_INSERT:
                changes.push(new TextChange(pos, CHANGE_TYPE.insert, seg[1]));
                pos += seg[1].length;
                break;
            case DIFF_DELETE:
                changes.push(new TextChange(pos, CHANGE_TYPE.delete, seg[1]));
                break;
        }
    }

    return changes;
}

function revert(str, changes) {
    if (!changes || changes.length < 1) return str;

    let res = str;
    for (let i = changes.length - 1; i > -1; i--) {
        const c = changes[i];
        if (c.t == CHANGE_TYPE.insert) {
            res = res.substring(0, c.p) + res.substring(c.p + c.d.length);
        } else {
            res = res.substring(0, c.p) + c.d + res.substring(c.p);
        }
    }
    return res;
}

export { compare, revert };

/**
 * compare
 */
const str1 = "This is a good way.";
const str2 = "this could be a nice choice?";
console.log(str1);
console.log(str2);
const changes = compare(str1, str2);
console.log("#-# changes:", changes);
const revertd = revert(str2, changes);
console.log("#-# revert right?", revertd);

/**
 * for dom
 */
import domUtil from "../util/dom.js";
import { POSTIL_TYPE } from "./batch";

const SYMBOLS = {
    clsSeg: "seg",
    clsSegWrapper: "seg-text",
    clsSegSymbol: "seg-symbol",
    ClssegStart: "seg-start",
    clsSegEnd: "seg-end",
    dSegWrapper: "seg-text",
    dTagFor: "data-tag-for",
    dType: "data-type",
    dTagName: "data-tag-name",

    clsPostil: "seg-co",
    clsPostilCompatibility: "co",
    dPostilId: "data-id",
    dPostilOrder: "data-order",
};

class TagDes {
    constructor(tag, el) {
        this.tag = tag;
        this.el = el;
    }
}

function generateTagStyle(tagType) {
    switch (tagType) {
        case "b":
            return { fontWeight: "bold" };
        case "i":
            return { fontStyle: "italic" };
        case "s":
            return { textDecoration: "line-through" };
        case "u":
            return { textDecoration: "underline" };
        case "sup":
            return { verticalAlign: "super" };
        case "sub":
            return { verticalAlign: "sub" };
        default:
            return null;
    }
}

function isSeg(el) {
    return domUtil.hasCls(el, SYMBOLS.clsSeg);
}

/**
 *
 * @param {Element} el
 * @returns
 */
function isSegSymbol(el) {
    return domUtil.hasCls(el, SYMBOLS.clsSeg, SYMBOLS.clsSegSymbol);
}

/**
 *
 * @param {Element} el
 * @returns
 */
function isInSegSymbol(el) {
    let curNode = el;
    while (curNode != null) {
        if (isSegSymbol(curNode)) return curNode;
        curNode = curNode.parentNode;
    }
    return null;
}

/**
 *
 * @param {Element} el
 */
function isInStyledTextNode(el) {
    let curNode = el;
    while (curNode != null) {
        if (domHelper.hasCls(curNode, "seg-text") && !!domHelper.attr(curNode, "data-sty-id")) return curNode;
        curNode = curNode.parentNode;
    }
    return null;
}

const STYLE_TAG_PREFIX = "sty_";
/**
 *
 * @param {String} tagName
 */
function isStyleTag(tagName) {
    return tagName.startsWith(STYLE_TAG_PREFIX);
}

function createTextSegWithTag(tagType, style) {
    return domUtil.div({
        attrs: { [SYMBOLS.dType]: SYMBOLS.dSegWrapper, [SYMBOLS.dTagName]: tagType },
        classes: [SYMBOLS.clsSeg, SYMBOLS.clsSegWrapper],
        styles: style || generateTagStyle(tagType),
    });
}

/**
 *
 * @param {Element} el
 */
function isPostil(el) {
    console.log("!is postil,", SYMBOLS.clsSeg, SYMBOLS.clsSegSymbol, SYMBOLS.clsPostilCompatibility);
    console.log(el, domUtil.hasCls(el, SYMBOLS.clsSeg, SYMBOLS.clsSegSymbol, SYMBOLS.clsPostilCompatibility));
    return domUtil.hasCls(el, SYMBOLS.clsSeg, SYMBOLS.clsSegSymbol, SYMBOLS.clsPostilCompatibility);
}

function createPostil(postil) {
    return domUtil.ele(
        "span",
        {
            attrs: {
                [SYMBOLS.dPostilId]: postil.id,
                [SYMBOLS.dPostilOrder]: postil.type == POSTIL_TYPE.normal ? postil.order : null,
            },
            classes: [
                SYMBOLS.clsSeg,
                SYMBOLS.clsSegSymbol,
                SYMBOLS.clsPostil,
                SYMBOLS.clsPostilCompatibility,
                postil.type,
            ],
        },
        [domUtil.text(postil.src)]
    );
}

/**
 *
 * @param {Element} postilElement
 * @param {{type:String,description:string}} postil
 */
function updatePostilElement(postilElement, postil) {
    postilElement.className = `${SYMBOLS.clsSeg} ${SYMBOLS.clsSegSymbol} ${SYMBOLS.clsPostil} ${postil.type}`;
}

/**
 *
 * @param {*} htmlFrame
 * @returns
 */
function createDel(htmlFrame) {
    return domUtil.ele("del", { attrs: { [SYMBOLS.dTagName]: "del" } }, htmlFrame);
}

function createIns(htmlFrame) {
    return domUtil.ele("ins", { attrs: { [SYMBOLS.dTagName]: "ins" } }, htmlFrame);
}

/**
 *
 * @param {ParentNode} fragment
 * @param {String} tagName
 */
function flatTagLevel(fragment, tagType) {
    if (!fragment.childNodes || fragment.childNodes.length < 1) return fragment;
    for (let i = 0; i < fragment.childNodes.length; i++) {
        const tempNode = fragment.childNodes[i];
        console.log("#-# flatTagLevel");
        if (isSeg(tempNode)) {
            const tagName = domUtil.attr(tempNode, SYMBOLS.dTagName);
            if (tagName === tagType) {
                const tempParent = tempNode.parentNode;
                const preNode = tempNode.previousSibling;
                const nextNode = tempNode.nextSibling;
                tempNode.remove();
                while (tempNode.childNodes.length > 0) {
                    if (!!preNode && domUtil.isText(preNode) && domUtil.isText(tempNode.childNodes[0])) {
                        preNode.textContent += tempNode.childNodes[0].textContent;
                        tempNode.childNodes[0].remove();
                    } else {
                        !!nextNode
                            ? tempParent.insertBefore(tempNode.childNodes[0], nextNode)
                            : tempParent.appendChild(tempNode.childNodes[0]);
                    }
                }
                i--;
                continue;
            }
        }
        flatTagLevel(tempNode, tagType);
    }
    return fragment;
}

/**
 *
 * @param {Node} el
 * @returns
 */
function checkNodeAsAWhole(el) {
    return isSegSymbol(el);
}

/**
 *
 * @param {Node} el
 */
function findPreviewsText(el) {
    let curEl = el;

    while (true) {
        if (domUtil.isText(curEl)) return curEl;

        if (checkNodeAsAWhole(curEl)) {
        }
    }
}

/**
 *
 * @param {Node} el
 */
function findLastEditChild(el, root, skipSelf, onlyTextNode) {
    if (!el || !domUtil.isAncestorOf(root, el)) return null;

    let curEl = el;
    function movePreview() {
        if (!checkNodeAsAWhole(curEl) && curEl.childNodes.length > 0) {
            curEl = curEl.lastChild;
        } else {
            if (curEl.previousSibling) {
                curEl = curEl.previousSibling;
            } else {
                let ancestor = curEl;
                while (!ancestor.previousSibling && ancestor != root) {
                    ancestor = ancestor.parentNode;
                }
                ancestor = ancestor === root ? null : ancestor;
                curEl = !!ancestor ? ancestor.previousSibling : null;
            }
        }
    }

    if (skipSelf) movePreview();
    while (curEl) {
        if (domUtil.isText(curEl) && curEl.textContent.length > 0) return curEl;
        if (checkNodeAsAWhole(curEl) && !onlyTextNode) return curEl;
        movePreview();
    }
    return curEl;
}

export {
    TagDes,
    SYMBOLS,
    isSeg,
    isSegSymbol,
    isInSegSymbol,
    createTextSegWithTag,
    createDel,
    createIns,
    flatTagLevel,
    findLastEditChild,
    createPostil,
    isPostil,
    updatePostilElement,
    isStyleTag,
    isInStyledTextNode,
};
